import type { Theme } from '@mui/material/styles';

const Timeline = (theme: Theme) => {
  return {
    MuiTimelineConnector: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.divider,
        },
      },
    },

    MuiTimelineDot: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
  };
};

export default Timeline;
